// TODO: a lot pasted initially from graphicStampUiModel -- see common areas

/* State Logic here will be shared on the note view and canvas */
/* Kind of a like a state object */


var  _ = require('underscore'),
    NoteUiModel = require('../../../../../noteUI'),
    fvChannel = require('glRadio').channel('FV'),
    DynamicInputCollection = require('./variableInputs/dynamicInputCollection'),
    VariableInputModel = require('./variableInputs/variableInputModel'),
    TokenInputModel = require('./variableInputs/tokenInput'),
    Util = require('../../../../../../../FV/util'),
    NormalizeNewLineCharacters = Util.normalizeNewLineCharacters;


module.exports = NoteUiModel.extend({
    // Fonts:  originally was testing vs Liberation Sans, Liberation Mono, Liberation, Courier New ( of the Liberation fonts )
    // Now we have the go ahead to use the MS core fonts but just using these:
    // - in case there is an issue with the others not being installed so we can fall back to the liberation ones
    // - there aren't many 'big names' fonts in MS fonts anyway
    // If coordination with CRE was possible, we could provide exact fonts and there would be no issue -- though the liberation ones should be
    // installed and metrically equivalent
    // Worse case is we serve the liberation ones but CRE will not check to see what font it uses
    availableFonts: [ 'Arial', 'Courier New', 'Times New Roman' ],

    availableFontSizes: [ 8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72 ], // those from MS-word

    defaults:  _.extend({}, NoteUiModel.prototype.defaults, {

        version: '1.0', // where storing the current -- will be used for new stamps and to save that of originals ( could call current version )

        selectedStamp: null,
        variableInputs: null,
        tokenInputs: null,

        generatedText: null,  // store to trigger a change
        inputsValid: false, // may want to trigger though may not need; not trigger for time being ....
        stampPlaced: false,

        // Other characteristics ...
        fontSize: 36, // Same as signatures, this should be a config option; idea of making it proportional to the size of the page
        font: 'Arial',

        // Note: must use here and then pull into the parent note model class, not vice versa
        // TODO: do we remember the last selected like with graphic notes? -- we store this on the defaultFor the noteModel

        textColor: '#000000', //
        textOpacity: 1.0,

        rotationAtZeroPageRotation: 0, // These are created at a rotation of 0; we need to know the rotation at which they were created -- should always be 0 for those creating

        // * Set if read in from template and the originalSelectedStamp.isDerivedFromPageNote */
        originalStampVariables: null,
        originalStampTokens: null,
        useNewTokenValues: false // ( always default by default )


    }),

    /**
     * Set on init -- only would apply to new -- currently no link on modify
     * Should move to constructor ...
     * Maybe easier to do from the note model -- setting the stamp on init after the ui model has been created
     * Also could be easier to put some of this sutff on a shape model
     */
    initialize: function() {

        NoteUiModel.prototype.initialize.apply(this, arguments);

        // There is no selected stamp / link to the original on modify -- if modify will have been set on parse
        if ( this.get('parent').isNew() )
        {
            var user = fvChannel.request('user');

            if ( user.hasTextStamps() ) {

                this.setSelectedStamp( user.getTextStamps().getDefaultStampForNewNote() );

            }
        }

        else {

            // This is the case when read in initially -- not after an original save -- see parent model parse code
            // Refactor needed....


            this.set({
                rotationAtZeroPageRotation: this.parent.rotationAtZeroPageRotation,
                font: this.parent.fontFamily,
                fontSize: this.parent.fontSize,
                stampPlaced: this.parent.stampPlaced,
                textColor: this.parent.textColor,
                textOpacity: this.parent.textOpacity
            });


            /* Do before selected stamp */

            if ( this.parent.originalVariables ) {
                this.setOriginalStampVariableInputs( this.parent.originalVariables );
            }

            if ( this.parent.originalTokens ) {
                this.setOriginalTokenValues( this.parent.originalTokens );
            }

            // Also sets version
            this.setSelectedStamp( this.parent.existingStamp );


        }

    },

    resetOnCancelChanges: function() {

        NoteUiModel.prototype.resetOnCancelChanges.apply( this, arguments );

        // Reset values on here vs shape ( here 'text' attributes of the note ) .... quick hack ...
        // Will want to change WF of parse/init of the parent note model ... ( see code )
        this.initialize( {parent: this.parent} );

    },

    /**
     * Central Pt -- also sets variableInputs, tokens from the stamp, and generatedText.
     *
     */
    setSelectedStamp: function( stamp ) {

        /* Variable inputs */
        this.set({
            variableInputs: null,
            tokenInputs: null,
            useNewTokenValues: false // always change back to false
        });

        var inputCollection;

        if ( stamp.isDerivedFromPageNote() && stamp.hasVariables() ) {

            // BB collection clone leaves references
            inputCollection = new DynamicInputCollection( this.get('originalStampVariables').toJSON() );
            this.set( 'variableInputs', inputCollection );
            this.set({ inputsValid: inputCollection.allInputsAreValid() }) ; // ( Should be true )

        } else {

            var selectStampHasVariables = stamp.hasVariables();

            if (selectStampHasVariables) {

                // this may be heavier than we need with backbone ....
                inputCollection = new DynamicInputCollection();

                stamp.getVariables().forEach( function(v) {

                    // Assuming coming from new.. don't need values and they are all invalid
                    inputCollection.add({
                        key: v,
                        keyNoSymbol: v.substring(1)
                    });

                });

                this.set('variableInputs', inputCollection);
            }

            this.set({ inputsValid: selectStampHasVariables ? false : true }); // inputCollection.allInputsAreValid() -- isNew, can't be valid


        }

        if ( stamp.hasTokens() ) {

            this.set( 'tokenInputs', this._getTokenInputs( stamp ) );

        }

        this.set({ generatedText: this._derivedGeneratedText(stamp) }, {silent: true} );

        this.set( 'selectedStamp', stamp ); /* trigger event */

    },

    _getTokenInputs: function( stamp ) {

        stamp = stamp || this.getSelectedStamp();

        if ( stamp.isDerivedFromPageNote() && !this.get('useNewTokenValues') ) {

            return new DynamicInputCollection( this.get('originalStampTokens').toJSON() );

        } else {

            var tokenModels = stamp.getTokens().map( function( t ) {

                var m = new TokenInputModel({
                    key: t,
                    keyNoSymbol: t.substring(1)
                });

                m.set( 'value', m.getNewGeneratedValue() );

                return m;

            });

            return new DynamicInputCollection( tokenModels );
        }

    },

    updateInputVariableValue: function( variableKey, value ) {

        // Update that model
        var variableInputModel = this.getVariableInputs().get( variableKey );
        variableInputModel.setValue( value ); // ( handles is valid -- maybe can rid -- just derived )

        // Now update the generated values ....
        this.set({
            inputsValid: this.getVariableInputs().allInputsAreValid(),
            generatedText: this._derivedGeneratedText()  // triggers event
        });

    },

    /**
     * objVariables: key/value pairs of the variables' keys and values.
     */
    setOriginalStampVariableInputs: function( objVariables ) {

        var inputCollection = new DynamicInputCollection();

        for ( var k in objVariables ) {

            var m = new VariableInputModel({
                key: k,
                keyNoSymbol: k.substring(1)
            });

            m.setValue( objVariables[k] );
            inputCollection.add(m);
        }

        this.set( 'originalStampVariables', inputCollection );

    },

    setOriginalTokenValues: function( objTokens ) {

        var inputCollection = new DynamicInputCollection();

        for ( var k in objTokens ) {

            var m = new VariableInputModel({
                key: k,
                keyNoSymbol: k.substring(1),
                value: objTokens[k]
            });

            inputCollection.add(m);
        }

        this.set( 'originalStampTokens', inputCollection );

    },


    /**
     * Could optimize more on init if necessary ( the non variable part )
     * EOL whitespace:
     * - normalize here again although aren't don't on load for the stamp module
     * - variable could change and could prevent EOL characters or prevent on change, but simpler to to here
     * - ( Raphael text relies on '\n' to create it's tspans
     */
    _derivedGeneratedText: function( stamp ) {

        stamp = stamp || this.getSelectedStamp(); // ( former for init )

        var output = stamp.getText();

        // Replace tokens first

        if ( stamp.hasTokens() ) {

            this.getTokenInputs().each( function( t ) {

                // To replace multiple, need to use a regExp; when ditch IE support, use replaceAll with a string. ( eg $date$date )
                // Could cache for better optimization.
                output = output.replace( new RegExp(  Util.escapeRegExp( t.get('key') ), 'g'), t.get('value') );

            });

        }

        if ( stamp.hasVariables() ) {

            this.getVariableInputs().each( function( variableInputModel ) {

                var inputValue = variableInputModel.get('value');

                // If nothing entered, leave the token in the preview
                if ( inputValue && inputValue.length > 0 ) {

                    // could store on the model for speed ...
                    var escapedKey = Util.escapeRegExp( variableInputModel.get('key') ); // ( always starts with % )

                    /**
                     * Dupes  are all set with the same value.
                     * \b -- see input on the stamps module:
                     *  - now that all incoming variable must be there own words, get those with the exact number of characters
                     *  - eg: %pet10 %pet1 would just match %pet1 ( and %pet10%pet1 could not exist )
                     */
                    var inputKeyRegExp = new RegExp( escapedKey + '\\b' , 'g' );

                    output = output.replace( inputKeyRegExp, variableInputModel.get('value') );

                }

            });

        }


        output = NormalizeNewLineCharacters( output );

        return output;

    },

    getSelectedStamp: function() {
        return this.get('selectedStamp');
    },

    getVariableInputs: function() {
        return this.get('variableInputs');
    },

    getTokenInputs: function() {
        return this.get('tokenInputs');
    },

    getGeneratedText: function() {
        return this.get('generatedText');
    },

    /* Implies ready to be stamped */
    getInputsValid: function() {
        return this.get('inputsValid');
    },
    getFont: function() {
        return this.get('font');
    },
    getFontSize: function() {
        return this.get('fontSize');
    },

    getFontSizesToPopulateDropdown: function() {

        var currentFontSize = this.getFontSize();

        if ( this.availableFontSizes.indexOf( currentFontSize ) > 0 )  {

            return this.availableFontSizes;
        }
        else {

            return [currentFontSize].concat( this.availableFontSizes ).sort( function( a, b) {
                return a - b;
            });
        }

    },

    getFontsToPopulateDropdown: function() {

        return this.availableFonts;

    },

    setStampPlaced: function( isPlaced ) {
        this.set( 'stampPlaced', isPlaced );
    },

    hasVariableInputs: function() {

        var inputs = this.getVariableInputs();

        return inputs && inputs.length > 0;

    },

    /** ( Use seperate sets as functions rely on state/attribute values ) */
    toggleUseNewTokenValues: function( ) {

        this.set( 'tokenInputs', null );

        this.set({ useNewTokenValues: !this.get('useNewTokenValues') });

        this.set({ tokenInputs: this._getTokenInputs( this.get('selectedStamp') )} );

        this.set({ generatedText: this._derivedGeneratedText()  } ) ; // triggers event

    },

    // Triggers an event -- color and opacity must be separate controls b/c color could be disabled!
    //setTextColorAndOpacity: function( color, opacity ) {
    //
    //    this.set({
    //        textColor: color,
    //        textOpacity: +(opacity.toFixed(2) )
    //    });
    //
    //},
    //

    setTextColor: function( color ) {
        this.set( 'textColor', color );
    },

    setTextOpacity: function( alpha ) {

        this.set( 'textOpacity', alpha );

    },

    getTextColor: function() {
        return this.get('textColor');
    },

    getTextOpacity: function() {
        return this.get('textOpacity');
    },

    /**
     * Logic containing the color rules -- here v. larger refactor with canvas
     * TODO: clean / and refactor -- this is copy'd from the canvas code
     * would like to move that logic to the note model, for the other note types -- we don't have the shapes zone color on the note
     * this would be something look into more when implemented color pickers for the other zones
     */
    getColorToApply: function() {

        if ( fvChannel.request('supportConsults') ) {

            var consultGroupColor = this.parent.getCurrentConsultColorForShapes(); // logic appears to handle setting this live ( vs deriving from selected consult groups )
            if (consultGroupColor)
                return consultGroupColor;
        }

        // 2) Groups of Note Creation User ( if belongs to one group with 1 color assigned )
        // ( must override zone color -- otherwise  group color would never get applied ( see discussion in ticket DVBC-1780 )
        var noteCreationUserGroupColor = this.parent.getCreationUserGroupColor();
        if ( noteCreationUserGroupColor ) {
            return noteCreationUserGroupColor;
        }

        // 3) Zone Color -- here, stored on this model -- default would already have been set before this is called
        // ( There are no 'currentDrawing attributes' coming from the graphic shape toolbar here )
        return this.get( 'textColor' );


    },

    getVersion: function() {

        return this.get('version');

    }


});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/drawable/svg/textStamp/uiModel.js
 ** module id = 338
 ** module chunks = 0
 **/